<template>
  <div class="banner__layout banner_project">
    <div class="banner__top">
      <div
        class="banner__button button button_primary"
        @click="toggleTabs"
        v-intro="$t('HINTS.PROJECT_HINT_STEP_2')"
        v-intro-step="2"
        v-intro-if="hints('project') && $route.path.length === 4"
      >
        <span v-if="tabs.currentTab === 'ProjectBannerInfoTab'">{{
          this.$t("VUE.STATISTICS")
        }}</span>
        <span v-else>{{ this.$t("VUE.DESCRIPTION") }}</span>
      </div>
    </div>
    <keep-alive>
      <component :is="component"></component>
    </keep-alive>
  </div>
</template>

<script>
import {
  ProjectBannerChartTab,
  ProjectBannerInfoTab
} from "@/components/app/Banners/Tabs";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProjectBanner",
  data() {
    return {
      button: { text: this.$t("VUE.STATISTICS") },
      tabs: { currentTab: "ProjectBannerInfoTab", hasToggled: false }
    };
  },
  methods: {
    ...mapActions(["fetchChartData"]),
    toggleTabs() {
      this.tabs.hasToggled = !this.tabs.hasToggled;
      !this.tabs.hasToggled
        ? (this.tabs.currentTab = "ProjectBannerInfoTab")
        : (this.tabs.currentTab = "ProjectBannerChartTab");
    }
  },
  computed: {
    ...mapGetters(["hints"]),
    component() {
      return this.tabs.currentTab;
    }
  },
  components: {
    ProjectBannerChartTab,
    ProjectBannerInfoTab
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.banner {
  .banner_project {
    .banner {
      &__top {
        display: flex;
      }

      &__button {
        padding: 5px 30px;
      }
    }
  }
}

.tab {
  display: flex;
  justify-content: center;

  &__right {
    img {
      width: 80%;
      margin: 0 auto;
    }
  }

  &__center {
    h2 {
      text-align: center;
      line-height: 1.1;
    }
  }

  &__chart {
    &-labels,
    &-label {
      display: flex;
      align-items: center;
    }

    &-labels {
      flex-wrap: wrap;
      max-width: 500px;
      margin: 20px auto;
    }

    &-label {
      margin: 5px;

      div {
        width: 55px;
        height: 20px;
        margin: 0 5px 0 0;
      }
    }

    &-wrap {
      height: 300px;
    }
  }

  &__left,
  &__right {
    flex-basis: 50%;
  }

  @media screen and (min-width: $min-lg) {
    &__center {
      margin: 20px 0 0;

      h2 {
        font-size: 32px;
      }
    }

    &__chart {
      &-label {
        flex-basis: calc((100% / 3) - 10px);
      }
    }
  }

  @media screen and (max-width: $max-md) {
    flex-direction: column;

    &__left {
      h1 {
        margin: 0 0 20px;
      }
    }
  }

  &__right {
    margin: 30px 0 0;
  }
}
</style>
